import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import TagsInput, { type TagsInputProps, type TagsInputLabels } from './TagsInput';
import { useTagSearch } from './useTagSearch';
import { MAX_TAGS, MAX_TAG_LENGTH } from './tagValidation';

type SearchableTagsInputProps = Omit<TagsInputProps, 'options' | 'onInputChange' | 'onDropdownOpen' | 'labels'>;

const SearchableTagsInput: React.FC<SearchableTagsInputProps> = observer((props) => {
  const { t } = useTranslation('components');
  const [searchTerm, setSearchTerm] = useState('');
  const { results, loading, refetch } = useTagSearch(searchTerm);

  const labels: TagsInputLabels = useMemo(() => ({
    placeholder: t('tagsInput.placeholder'),
    tagLimit: t('tagsInput.tagLimitError', { max: MAX_TAGS }),
    tagTooLong: t('tagsInput.tagTooLong', { max: MAX_TAG_LENGTH }),
    invalidChars: t('tagsInput.invalidTagCharacters'),
    addTag: (tag: string) => t('tagsInput.addTag', { tag }),
    emptyStateTitle: t('tagsInput.emptyState.title'),
    emptyStateDescription: t('tagsInput.emptyState.description'),
    noResultsTitle: t('tagsInput.noResults.title'),
    noResultsDescription: t('tagsInput.noResults.description'),
  }), [t]);

  return (
    <TagsInput
      {...props}
      options={results}
      onInputChange={setSearchTerm}
      onDropdownOpen={() => refetch(searchTerm, { forceNetwork: true })}
      labels={labels}
      loading={loading}
    />
  );
});

export default SearchableTagsInput;
